import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import routerConstant from "service/constant/routerConstant";
import type { IInquiryList } from "service/interface/help";

interface Props {
  data: IInquiryList[];
}

export function InquiryListTable({ data }: Props) {
  const navigate = useNavigate();

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.INQUIRY.index}/${id}`);
  };

  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[93px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              이름
            </th>
            <th
              scope="col"
              className="min-w-[149px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              휴대폰 번호
            </th>
            <th
              scope="col"
              className="min-w-[480px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              제목
            </th>
            <th
              scope="col"
              className="min-w-[109px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              답변 상태
            </th>
            <th
              scope="col"
              className="min-w-[137px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              생성일
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((member) => (
            <tr
              key={member.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
              onClick={() => handleTableClick(member.id)}
            >
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {member.id}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {member.User?.name}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {member.User?.phoneNumber}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {member.title}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {member.isAnswer ? "답변완료" : "대기중"}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(member.createdAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
